export { useCreateTeam } from '@dc-shared-web/hooks/api/team/useCreateTeam'
export { useGetMultiTeamDetails } from '@dc-shared-web/hooks/api/team/useGetMultiTeamDetails'
export { useGetTeamByUUID } from '@dc-shared-web/hooks/api/team/useGetTeamByUUID'
export { useGetTeams } from '@dc-shared-web/hooks/api/team/useGetTeams'
export { useGetTeamSelectOptions } from '@dc-shared-web/hooks/api/team/useGetTeamSelectOptions'
export { useUpdateTeam } from '@dc-shared-web/hooks/api/team/useUpdateTeam'

export { fetchTeamByUUID } from '@dc-shared-web/hooks/api/team/fetchTeamByUUID'
export { getTeamSelectOptions } from '@dc-shared-web/hooks/api/team/getTeamSelectOptions'
export type { GetTeamQueryParams } from '@dc-shared-web/hooks/api/team/fetchTeamByUUID'
export type {
  GetTeamsSelectOptionsParams,
  GetTeamsSelectOptionsResponse,
} from '@dc-shared-web/hooks/api/team/getTeamSelectOptions'

export { TEAMS_BASE_QUERY_KEY } from '@dc-shared-web/hooks/api/team/constants'

export type {
  TeamsDetailsMeta,
  TeamDetailsData,
  TeamDetails,
  Team,
  BasicTeam,
} from '@dc-shared-web/hooks/api/team/types'
